import React, { useEffect, useState } from "react";
import { Modal, Button, Card, Badge, Dropdown } from "react-bootstrap";

const BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:8000";

const SPICE_LEVELS = [
    { value: "mild", label: "1 マイルド" },
    { value: "medium", label: "2 🌶🌶  普通" },
    { value: "hot", label: "3 🌶🌶🌶 中辛" },
    { value: "very_hot", label: "4 🌶🌶🌶🌶  大辛 " },
    { value: "super_hot", label: "5 🌶🌶🌶🌶🌶  激辛 " },
];

const SlotSelectionModal = ({
                                show,
                                onHide,
                                activeSlot,
                                slotData,
                                selectedFoods,
                                handleFoodSelect,
                                handleConfirmSlot,
                            }) => {
    const [foodsToShow, setFoodsToShow] = useState([]);

    useEffect(() => {
        if (!activeSlot || !slotData) return;

        const matchedCategory = slotData.find(
            (cat) => cat.id === activeSlot.category_id && cat.set_menu_id == activeSlot.id
        );

        setFoodsToShow(matchedCategory ? matchedCategory.foods : []);
    }, [activeSlot, slotData]);

    if (!activeSlot) return null;

    const renderSpiceDropdown = (food) => {
        if (activeSlot.category_id !== 9) return null;
        const currentSpice = food.spice_level || "";

        return (
            <Dropdown className="mt-2">
                <Dropdown.Toggle size="lg" variant="outline-light" className="w-100">
                    {currentSpice ? SPICE_LEVELS.find((l) => l.value === currentSpice)?.label : "Spice"}
                </Dropdown.Toggle>
                <Dropdown.Menu>
                    {SPICE_LEVELS.map((level) => (
                        <Dropdown.Item
                            key={level.value}
                            active={currentSpice === level.value}
                            onClick={() => {
                                food.spice_level = level.value;
                            }}
                        >
                            {level.label}
                        </Dropdown.Item>
                    ))}
                </Dropdown.Menu>
            </Dropdown>
        );
    };

    return (
        <Modal
            show={show}
            onHide={onHide}
            size="xl" // Make modal extra-large
            centered
            style={{ maxWidth: "95%" }}
        >
            <Modal.Header closeButton>
                <Modal.Title>
                    {activeSlot.type === "changeable" ? "Change Item" : "Choose Item"}
                    {activeSlot.type === "choosable" && activeSlot.quantity && (
                        <span style={{ fontWeight: 500, marginLeft: 10 }}>
                            (Select up to {activeSlot.quantity})
                        </span>
                    )}
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <div className="d-flex flex-wrap justify-content-start">
                    {foodsToShow.map((food) => {
                        if (!food.set_menu_image) return null;
                        const isSelected = selectedFoods.find((f) => f.id === food.id);
                        const disableSelect =
                            activeSlot.type === "choosable" && !isSelected && selectedFoods.length >= activeSlot.quantity;

                        return (
                            <div
                                key={food.id}
                                className="me-4 mb-4"
                                style={{
                                    width: 220, // larger card width
                                    cursor: disableSelect ? "not-allowed" : "pointer",
                                    opacity: disableSelect ? 0.5 : 1,
                                }}
                                onClick={() => !disableSelect && handleFoodSelect(food)}
                            >
                                <Card
                                    className={isSelected ? "border-primary" : ""}
                                    bg="dark"
                                    text="white"
                                    style={{ height: 280 }} // larger card height
                                >
                                    <Card.Img
                                        variant="top"
                                        src={
                                            food.images?.[0]
                                                ? `${BASE_URL}/storage/${food.set_menu_image}`
                                                : "/images/default-placeholder.jpg"
                                        }
                                        height={150} // larger image height
                                        style={{ objectFit: "cover" }}
                                        onError={(e) => (e.target.src = "/images/default-placeholder.jpg")}
                                    />
                                    <Card.Body className="p-3 text-center d-flex flex-column justify-content-between">
                                        <div>
                                            <Card.Title style={{ fontSize: 16, fontWeight: 600 }}>
                                                {food.japanese_name}
                                            </Card.Title>
                                            {food.additional_price > 0 && (
                                                <Card.Text style={{ fontSize: 14, color: "#ffd700" }}>
                                                    +¥{parseFloat(food.additional_price || 0).toFixed(0)}
                                                </Card.Text>
                                            )}
                                        </div>
                                        {activeSlot.type !== "fixed" && renderSpiceDropdown(food)}
                                        <Button
                                            size="lg"
                                            variant={isSelected ? "primary" : "secondary"}
                                            className="mt-3 w-100"
                                        >
                                            {isSelected ? "選択済み" : " 選択"}
                                        </Button>
                                    </Card.Body>
                                </Card>
                            </div>
                        );
                    })}
                </div>
            </Modal.Body>

            <Modal.Footer>
                <Button variant="secondary" onClick={onHide} size="lg">
                    中止
                </Button>
                <Button variant="primary" onClick={handleConfirmSlot} size="lg">
                    確認
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default SlotSelectionModal;
